import React, { useCallback, useEffect } from "react";

import {
  AudioTestState,
  DeviceTesterTestState,
} from "../../../types/Device.types";
import { DeviceTesterActionType } from "../../device-tester-context-provider/Reducer.types";
import {
  useDeviceTesterDispatchContext,
  useDeviceTesterStateContext,
} from "../../device-tester-context-provider/DeviceTesterContextProvider";

import { AudioTestView } from "./AudioTestView";

export const ConnectedAudioTestView: React.FC = () => {
  const { deviceTesterState } = useDeviceTesterStateContext();
  const { deviceTesterDispatch } = useDeviceTesterDispatchContext();

  // Handle connection failure, if call has been started transition directly to results deviceTesterState.AudioTestState
  // to avoid long delay
  const handleConnectionFailure = useCallback(() => {
    if (deviceTesterState.audioTestState === AudioTestState.STARTED) {
      deviceTesterDispatch({
        type: DeviceTesterActionType.SET_DEVICE_TEST_STATE,
        state: DeviceTesterTestState.RESULTS,
      });
    }
  }, [deviceTesterState.audioTestState, deviceTesterDispatch]);

  useEffect(() => {
    window.addEventListener("offline", handleConnectionFailure);
    return () => window.removeEventListener("offline", handleConnectionFailure);
  }, [handleConnectionFailure]);

  return <AudioTestView testState={deviceTesterState.audioTestState} />;
};
